import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import SearchContextProvider from "./Context/SearchContext";
import AuthContextProvider from "./Context/AuthContext";
import FilterContextProvider from "./Context/FilterContext";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <FilterContextProvider>
    <AuthContextProvider>
      <SearchContextProvider>
        <BrowserRouter>
          <ChakraProvider>
            <App />
          </ChakraProvider>
        </BrowserRouter>
      </SearchContextProvider>
    </AuthContextProvider>
  </FilterContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
